import { render, staticRenderFns } from "./VOpenDaysDetail.vue?vue&type=template&id=cec48f58&"
import script from "./VOpenDaysDetail.vue?vue&type=script&lang=js&"
export * from "./VOpenDaysDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports